<template>

  <div class="upload-page">

    <div class="md-layout">

      <div class="md-layout-item md-size-100">

        <md-card class="upload-card">

          <!-- HEADER -->

          <md-card-header class="upload-header">

            <div class="header-content">

              <div>

                <h3 class="title">
                  Upload Labourers Excel
                </h3>

                <p class="subtitle">
                  Import labourers using Excel template
                </p>

              </div>

              <div class="header-actions">

<!--                <md-button-->
<!--                    class="md-primary md-raised action-btn"-->
<!--                    href="/templates/labourers-template.xlsx"-->
<!--                    target="_blank"-->
<!--                >-->
<!--                  <md-icon>download</md-icon>-->
<!--                  Download Template-->
<!--                </md-button>-->
                <md-button
                    class="md-primary md-raised action-btn"
                    href="#"
                    @click="downloadTemplate"
                >
                  <md-icon>download</md-icon>
                  Download Template
                </md-button>

                <md-button
                    @click="goBack"
                    class="md-simple md-primary"
                >
                  <md-icon>arrow_back</md-icon>
                  Back to List
                </md-button>

              </div>

            </div>

          </md-card-header>

          <md-card-content>

            <!-- UPLOAD SECTION -->

            <div class="upload-box">

              <!-- Vendor Selection -->
              <div class="vendor-selection mb-4">

                <label class="form-label">
                  Select Vendor
                </label>

                <md-field>
                  <label>Vendor</label>

                  <md-select
                      v-model="vendor_id"
                      :disabled="vendors.length === 0"
                  >

                    <md-option value="">
                      Select Vendor
                    </md-option>

                    <md-option
                        v-for="vendor in vendors"
                        :key="vendor.id"
                        :value="vendor.id"
                    >
                      {{ vendor.name }}
                    </md-option>

                  </md-select>
                </md-field>

              </div>


              <!-- Upload Icon -->
              <div class="upload-icon">
                <md-icon>upload_file</md-icon>
              </div>


              <h4>
                Select Excel File
              </h4>

              <p class="upload-description">
                Upload .xlsx or .xls file containing labourers information
              </p>


              <!-- File Upload -->
              <label class="custom-file-upload">

                <input
                    type="file"
                    accept=".xlsx,.xls"
                    ref="excel"
                    :disabled="vendor_id===''"
                    @change="handleFileUpload"
                >

                <span>
      Choose Excel File
    </span>

              </label>


              <!-- Selected File -->
              <div
                  v-if="selectedFileName"
                  class="selected-file"
              >

                <md-icon>description</md-icon>

                {{ selectedFileName }}

              </div>

            </div>

            <!-- SUMMARY -->

            <div
                v-if="labourers.length"
                class="summary-wrapper"
            >

              <div class="summary-card valid">

                <div class="summary-number">
                  {{ validCount }}
                </div>

                <div class="summary-label">
                  Valid Records
                </div>

              </div>
              <div class="summary-card warning">

                <div class="summary-number">
                  {{ warningCount }}
                </div>

                <div class="summary-label">
                  Warning Records
                </div>

              </div>

              <div class="summary-card invalid">

                <div class="summary-number">
                  {{ invalidCount }}
                </div>

                <div class="summary-label">
                  Invalid Records
                </div>

              </div>

              <div class="summary-card total">

                <div class="summary-number">
                  {{ labourers.length }}
                </div>

                <div class="summary-label">
                  Total Records
                </div>

              </div>

            </div>

            <!-- ACTION BAR -->

            <div
                v-if="labourers.length"
                class="action-bar"
            >

              <div class="action-info">

                <md-icon>info</md-icon>

                Review validation results before upload

              </div>

              <md-button
                  class="md-success md-raised upload-btn"
                  :disabled="
                  loading ||
                  labourers.length === 0 ||
                  validCount+warningCount === 0
                "
                  @click="uploadLabourers"
              >
<!--              <md-button-->
<!--                  class="md-success md-raised upload-btn"-->
<!--                  :disabled="-->
<!--                  loading ||-->
<!--                  labourers.length === 0-->
<!--                "-->
<!--                  @click="uploadLabourers"-->
<!--              >-->

                <md-icon>cloud_upload</md-icon>

                <span v-if="loading">
                  Uploading...
                </span>

                <span v-else>
                  Upload Labourers
                </span>

              </md-button>

            </div>

            <!-- TABLE -->

            <div
                v-if="labourers.length"
                class="table-container"
            >

              <table class="modern-table">

                <thead>

                <tr>

                  <th>#</th>
                  <th>Status</th>
                  <th>Full Name</th>
                  <th>Birth Date</th>
                  <th>Phone</th>
                  <th>NIDA</th>
                  <th>Gender</th>
                  <th>Email</th>
                  <th>Region</th>
                  <th>District</th>
                  <th>Ward</th>
                  <th>Village</th>
                  <th>Port</th>
                  <th>Department</th>
                  <th>Validation Results</th>

                </tr>

                </thead>

                <tbody>

                <tr
                    v-for="(item, index) in labourers"
                    :key="index"
                    :class="{
                    'row-invalid': item.errors.length,
                    'row-warning': !item.errors.length && item.warnings.length
                  }"
                >

                  <td>
                    {{ index + 1 }}
                  </td>

                  <!-- STATUS -->

                  <td>

                    <span
                        v-if="item.errors.length"
                        class="status-badge invalid"
                    >
                      Invalid
                    </span>

                    <span
                        v-else-if="item.warnings.length"
                        class="status-badge warning"
                    >
                      Warning
                    </span>

                    <span
                        v-else
                        class="status-badge valid"
                    >
                      Valid
                    </span>

                  </td>

                  <!-- NAME -->

                  <td>

                    <div class="name-cell">

                      <strong>
                        {{
                          [
                            item.first_name,
                            item.middle_name,
                            item.last_name
                          ]
                              .filter(Boolean)
                              .join(' ')
                        }}
                      </strong>

                    </div>

                  </td>

                  <!-- DOB -->

                  <td>
                    {{ item.birth_date || '-' }}
                  </td>

                  <!-- PHONE -->

                  <td>
                    {{ item.phone_number || '-' }}
                  </td>

                  <!-- NIDA -->

                  <td>
                    {{ item.nida_number || '-' }}
                  </td>

                  <!-- GENDER -->

                  <td>
                    {{ item.gender || '-' }}
                  </td>

                  <!-- EMAIL -->

                  <td>
                    {{ item.email || '-' }}
                  </td>

                  <!-- REGION -->

                  <td>
                    {{ item.region || '-' }}
                  </td>

                  <!-- DISTRICT -->

                  <td>
                    {{ item.district || '-' }}
                  </td>

                  <!-- Ward -->

                  <td>
                    {{ item.ward || '-' }}
                  </td>

                  <!-- VILLAGE -->

                  <td>
                    {{ item.village || '-' }}
                  </td>

                  <!-- PORT -->

                  <td>
                    {{ item.port || '-' }}
                  </td>

                  <!-- DEPARTMENT -->

                  <td>
                    {{ item.department || '-' }}
                  </td>

                  <!-- VALIDATION -->

                  <td class="validation-column">

                    <!-- ERRORS -->

                    <div
                        v-if="item.errors.length"
                        class="validation-group"
                    >

                      <div
                          v-for="(error, errorIndex) in item.errors"
                          :key="'error-' + errorIndex"
                          class="validation-item error"
                      >

                        <md-icon>
                          cancel
                        </md-icon>

                        {{ error }}

                      </div>

                    </div>

                    <!-- WARNINGS -->

                    <div
                        v-if="item.warnings.length"
                        class="validation-group"
                    >

                      <div
                          v-for="(warning, warningIndex) in item.warnings"
                          :key="'warning-' + warningIndex"
                          class="validation-item warning"
                      >

                        <md-icon>
                          warning
                        </md-icon>

                        {{ warning }}

                      </div>

                    </div>

                    <!-- NO ISSUES -->

                    <div
                        v-if="!item.errors.length && !item.warnings.length"
                        class="validation-item success"
                    >

                      <md-icon>
                        check_circle
                      </md-icon>

                      No Issues

                    </div>

                  </td>

                </tr>

                </tbody>

              </table>

            </div>

          </md-card-content>

        </md-card>

      </div>

    </div>

    <!-- LOADING -->

    <div
        v-if="loading"
        class="loading-overlay"
    >

      <div class="loading-content">

        <md-progress-spinner
            md-mode="indeterminate"
            :md-diameter="70"
            :md-stroke="6"
        />

        <h3>
          {{ loadingMessage }}
        </h3>

        <p>
          Please wait...
        </p>

      </div>

    </div>

  </div>

</template>

<script>

import * as XLSX from 'xlsx';
import axios from 'axios';

export default {

  name: 'UploadLabourers',

  data() {

    return {

      labourers: [],

      loading: false,

      loadingMessage: '',

      locations: [],

      ports: [],
      vendors: [],

      vendor_id: '',

      selectedFileName: '',

    };

  },

  async created() {

    await this.loadLocations();

    await this.loadPorts();
    await this.fetchVendors();

  },

  computed: {

    hasValidationErrors() {

      return this.labourers.some(
          item => item.errors.length
      );

    },

    validCount() {
      return this.labourers.filter(item =>
          (!item.errors || item.errors.length === 0) &&
          (!item.warnings || item.warnings.length === 0)
      ).length;
    },

    warningCount() {
      return this.labourers.filter(item =>
          (!item.errors || item.errors.length === 0) &&
          item.warnings &&
          item.warnings.length > 0
      ).length;
    },

    invalidCount() {
      return this.labourers.filter(item =>
          item.errors && item.errors.length > 0
      ).length;
    },

  },

  methods: {
    async fetchVendors() {

      console.log('selectedPort', this.selectedPort);

      let params = {
        filter: {
          station: this.selectedPort?.station_id
        }
      };

      console.log('params', params);

      await this.$store.dispatch('vendors/list', params);

      console.log(
          'vendors dropdown',
          this.$store.getters['vendors/dropdown']
      );

      this.vendors =
          this.$store.getters['vendors/dropdown'];
      console.log(this.vendors);
    },
    normalizePhone(phone) {

      if (!phone) {
        return '';
      }

      phone = phone
          .toString()
          .trim()
          .replace(/[\s-]+/g, '')
          .replace(/^\+/, '');

      if (phone.startsWith('0')) {
        phone = '255' + phone.substring(1);
      }

      return phone;
    },

    async handleFileUpload(event) {

      const file = event.target.files[0];

      if (!file) {
        return;
      }

      this.selectedFileName = file.name;

      const allowedTypes = [

        'application/vnd.ms-excel',

        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',

      ];

      if (!allowedTypes.includes(file.type)) {

        this.notify(
            'Please upload valid Excel file',
            'danger'
        );

        return;

      }

      this.loading = true;

      this.loadingMessage =
          'Reading Excel file';

      const reader = new FileReader();

      reader.onload = async (e) => {

        try {

          const data =
              new Uint8Array(
                  e.target.result
              );

          const workbook =
              XLSX.read(data, {
                type: 'array',
              });

          const firstSheet =
              workbook.Sheets[
                  workbook.SheetNames[1]
                  ];

          const jsonData =
              XLSX.utils.sheet_to_json(
                  firstSheet,
                  {
                    defval: '',
                  }
              );

          this.labourers = jsonData.map(row => {

            const item = {};

            Object.keys(row).forEach(key => {

              item[key.trim()] = row[key];

            });

            return {

              first_name:
                  item['FirstName'] || '',

              middle_name:
                  item['MiddleName'] || '',

              last_name:
                  item['LastName'] || '',

              birth_date:
                  this.parseExcelDate(
                      item['DateBirth']
                  ) || '',

              phone_number:
                  item['PhoneNo'] || '',

              nida_number:
                  item['NIDA_Number'] || '',

              gender:
                  item['Gender'] || '',

              email:
                  item['Email'] || '',

              region:
                  item['Region'] || '',

              district:
                  item['District'] || '',

              ward:
                  item['Ward'] || '',

              village:
                  item['Village_Street'] || '',

              port:
                  item['PortOfOperation'] || '',

              department:
                  item['Department'] || '',

              birth_certificate_number:
                  item['BirthCertificateNo'] || '',

              tribe:
                  item['Tribe'] || '',

              religion:
                  item['Religion'] || '',

              address:
                  item['PhysicalAddress'] || '',

              vendor_labourer_number:
                  item['LabourIDNo'] || '',

              skill:
                  item['Skill'] || '',

              errors: [],

              warnings: [],

            };

          });

          await this.validateLabourers();

          this.loading = false;

          this.$nextTick(() => {

            setTimeout(() => {

              this.notify(
                  `${this.labourers.length} records loaded successfully`,
                  'success'
              );

            }, 300);

          });

        } catch (error) {

          console.error(error);

          this.loading = false;

          this.notify(
              'Failed to read Excel file',
              'danger'
          );

        }

      };

      reader.readAsArrayBuffer(file);

    },

    async validateLabourers() {

      this.loading = true;

      this.loadingMessage =
          'Validating labourers';

      const phoneNumbers = [];

      const nidaNumbers = [];

      let existingPhones = [];

      let existingNidas = [];

      try {

        const API_URL =
            process.env.VUE_APP_API_BASE_URL;

        const response =
            await axios.post(
                `${API_URL}/labourers/validate-existing`,
                {
                  phones:
                      this.labourers.map(
                          x => x.phone_number
                      ),

                  nidas:
                      this.labourers.map(
                          x => x.nida_number
                      ),
                }
            );

        existingPhones =
            response.data.phones || [];

        existingNidas =
            response.data.nidas || [];

      } catch (error) {

        console.error(error);

      }

      this.labourers.forEach((item) => {

        item.errors = [];

        item.warnings = [];

        /*
        |--------------------------------------------------------------------------
        | NORMALIZE
        |--------------------------------------------------------------------------
        */

        item.first_name =
            this.capitalize(item.first_name);

        item.middle_name =
            this.capitalize(item.middle_name);

        item.last_name =
            this.capitalize(item.last_name);

        item.gender =
            this.capitalize(item.gender);

        item.email =
            item.email
                ? item.email.toLowerCase()
                : '';

        /*
        |--------------------------------------------------------------------------
        | REQUIRED
        |--------------------------------------------------------------------------
        */
        if (this.isEmpty(item.first_name)) {
          item.errors.push('First name required');
        }

        if (this.isEmpty(item.last_name)) {
          item.errors.push('Last name required');
        }

        if (this.isEmpty(item.birth_date)) {
          item.errors.push('Birth date required');
        }

        if (this.isEmpty(item.phone_number)) {
          item.errors.push('Phone required');
        }



        // if (!item.first_name) {
        //
        //   item.errors.push(
        //       'First name required'
        //   );
        //
        // }
        //
        // if (!item.last_name) {
        //
        //   item.errors.push(
        //       'Last name required'
        //   );
        //
        // }

        /*
|--------------------------------------------------------------------------
| PHONE
|--------------------------------------------------------------------------
*/

        if (!item.phone_number) {

          item.errors.push(
              'Phone required'
          );

        } else {

          item.phone_number = this.normalizePhone(item.phone_number);

          // Validate final normalized format
          const phoneRegex = /^255\d{9}$/;

          if (!phoneRegex.test(item.phone_number)) {

            item.errors.push(
                'Invalid phone'
            );

          } else {

            if (
                phoneNumbers.includes(
                    item.phone_number
                )
            ) {

              item.errors.push(
                  'Duplicate phone in Excel'
              );

            }
console.log(existingPhones);
            if (
                existingPhones.includes(
                    this.normalizePhone(item.phone_number)
                )
            ) {

              item.errors.push(
                  'Phone already exists'
              );

            }
            phoneNumbers.push(
                item.phone_number
            );

          }

        }

        /*
        |--------------------------------------------------------------------------
        | DATE OF BIRTH
        |--------------------------------------------------------------------------
        */

        if (item.birth_date) {

          const regex =
              /^\d{4}-\d{2}-\d{2}$/;

          if (!regex.test(item.birth_date)) {

            item.errors.push(
                'Birth date format must be YYYY-MM-DD'
            );

          } else {

            const birthDate =
                new Date(item.birth_date);

            if (
                isNaN(
                    birthDate.getTime()
                )
            ) {

              item.errors.push(
                  'Invalid birth date'
              );

            }

          }

        }

        /*
        |--------------------------------------------------------------------------
        | PORT
        |--------------------------------------------------------------------------
        */

        const portExists =
            this.ports.find(
                port =>
                    this.normalizeText(port.name) ===
                    this.normalizeText(item.port)
            );

        if (!portExists) {

          item.errors.push(
              'Invalid port'
          );

        }

        /*
        |--------------------------------------------------------------------------
        | DEPARTMENT
        |--------------------------------------------------------------------------
        */

        if (item.department) {

          if (!portExists) {

            item.errors.push(
                'Department validation failed because port is invalid'
            );

          } else {

            const departmentExists =
                portExists.departments?.find(
                    department =>
                        this.normalizeText(department.name) ===
                        this.normalizeText(item.department)
                );

            if (!departmentExists) {

              item.errors.push(
                  'Department does not belong to selected port'
              );

            }

          }

        }

        /*
/*
|--------------------------------------------------------------------------
| NIDA
|--------------------------------------------------------------------------
*/
        const nida = (item.nida_number || "")
            .toString()
            .trim()
            .replace(/[\s-]/g, "");

        item.nida_number=nida;
        console.log(nida);

        if (!nida) {
          item.errors.push("NIDA number is required");

        } else if (!/^\d{20}$/.test(nida)) {
          item.errors.push("NIDA number must contain exactly 20 digits");

        } else {
          // Validate DOB from first 8 digits: YYYYMMDD
          const dobPart = nida.substring(0, 8);

          const year = parseInt(dobPart.substring(0, 4), 10);
          const month = parseInt(dobPart.substring(4, 6), 10);
          const day = parseInt(dobPart.substring(6, 8), 10);

          const dob = new Date(year, month - 1, day);

          const isValidDob =
              dob.getFullYear() === year &&
              dob.getMonth() === month - 1 &&
              dob.getDate() === day;

          if (!isValidDob) {
            item.errors.push(
                "The first 8 digits of the NIDA number must be a valid date of birth (YYYYMMDD)"
            );
          }

          // Duplicate NIDA in current Excel
          if (nidaNumbers.includes(nida)) {
            item.errors.push("Duplicate NIDA in Excel");
          }

          // NIDA already exists in database
          if (existingNidas.includes(nida)) {
            item.errors.push("NIDA already exists");
          }

          nidaNumbers.push(nida);
        }

      /*
      |--------------------------------------------------------------------------
        | LOCATION WARNINGS
        |--------------------------------------------------------------------------
        | Put this AFTER:
            | item.warnings = [];
      |--------------------------------------------------------------------------
        */

        /*
        |--------------------------------------------------------------------------
        | REGION
        |--------------------------------------------------------------------------
        */

        let regionExists = null;

        if (item.region) {

          regionExists =
              this.locations.find(
                  region =>
                      this.normalizeText(region.name) ===
                      this.normalizeText(item.region)
              );

          if (!regionExists) {

            item.warnings.push(
                `Region "${item.region}" not found. It will be saved as empty.`
            );

          }

        }

        /*
        |--------------------------------------------------------------------------
        | DISTRICT
        |--------------------------------------------------------------------------
        */

        let districtExists = null;

        if (item.district) {

          if (!regionExists) {

            item.warnings.push(
                `District "${item.district}" cannot be validated because region is invalid.`
            );

          } else {

            const districtFullName = (item.district || "")
                .toString()
                .trim();

            districtExists = regionExists.districts.find(district => {

              let fullName = district.name;

              if (district.district_type && district.district_type.name) {
                fullName += " " + district.district_type.name;
              }

              return this.normalizeText(fullName) ===
                  this.normalizeText(districtFullName);
            });

            if (!districtExists) {

              item.warnings.push(
                  `District "${item.district}" not found under region "${item.region}".`
              );

            }

          }

        }

        /*
        |--------------------------------------------------------------------------
        | WARD
        |--------------------------------------------------------------------------
        */

        let wardExists = null;

        if (item.ward) {

          if (!districtExists) {

            item.warnings.push(
                `Ward "${item.ward}" cannot be validated because district is invalid.`
            );

          } else {

            wardExists =
                districtExists.wards.find(
                    ward =>
                        this.normalizeText(ward.name) ===
                        this.normalizeText(item.ward)
                );
            console.log("++++++++++")
console.log(districtExists.wards)
            console.log(item.ward)
            console.log("========");
            if (!wardExists) {

              item.warnings.push(
                  `Ward "${item.ward}" not found under district "${item.district}".`
              );

            }

          }

        }

        /*
        |--------------------------------------------------------------------------
        | VILLAGE
        |--------------------------------------------------------------------------
        */

        if (item.village) {

          if (!wardExists) {

            item.warnings.push(
                `Village "${item.village}" cannot be validated because ward is invalid.`
            );

          } else {

            const villageExists =
                wardExists.villages.find(
                    village =>
                        this.normalizeText(village.name) ===
                        this.normalizeText(item.village)
                );

            if (!villageExists) {

              item.warnings.push(
                  `Village "${item.village}" not found under ward "${item.ward}".`
              );

            }

          }

        }

      });


      this.loading = false;

    },
    isEmpty(value) {
      return (
          value === null ||
          value === undefined ||
          value.toString().trim() === ''
      );
    },

    async uploadLabourers() {

      this.loading = true;

      this.loadingMessage =
          'Uploading labourers';

      try {

        const API_URL =
            process.env.VUE_APP_API_BASE_URL;

        const response =
            await axios.post(
                `${API_URL}/labourers/bulk-upload`,
                {
                  labourers:
                      this.labourers.filter(
                          item =>
                              !item.errors.length
                      ),

                  vendor_id:
                  this.vendor_id,
                }
            );

        const data = response.data;


        /*
        |--------------------------------------------------------------------------
        | RESULT MESSAGE
        |--------------------------------------------------------------------------
        */

        this.notify(
            data.message,
            data.created > 0
                ? 'success'
                : 'warning'
        );


        /*
        |--------------------------------------------------------------------------
        | ERRORS
        |--------------------------------------------------------------------------
        */

        if (
            data.errors &&
            data.errors.length
        ) {

          data.errors.forEach(error => {

            this.notify(
                error,
                'danger'
            );

          });

        }


        /*
        |--------------------------------------------------------------------------
        | WARNINGS
        |--------------------------------------------------------------------------
        */

        if (
            data.warnings &&
            data.warnings.length
        ) {

          data.warnings.forEach(warning => {

            const message =
                typeof warning === 'string'
                    ? warning
                    : `Row ${warning.row}: ${warning.message}`;

            this.notify(
                message,
                'warning'
            );

          });

        }


        /*
        |--------------------------------------------------------------------------
        | CLEAR ONLY IF ALL WERE SUCCESSFUL
        |--------------------------------------------------------------------------
        */

        if (
            data.created > 0 &&
            (!data.errors || data.errors.length === 0)
        ) {

          this.labourers = [];

          this.selectedFileName = '';

          if (this.$refs.excel) {
            this.$refs.excel.value = '';
          }

        }

      } catch (error) {

        console.error(
            'Bulk upload error:',
            error
        );

        this.notify(
            error?.response?.data?.message ||
            'Upload failed',
            'danger'
        );

      } finally {

        this.loading = false;

      }

    },

    parseExcelDate(value) {

      if (typeof value === 'number') {

        const parsed =
            XLSX.SSF.parse_date_code(value);

        if (!parsed) {
          return '';
        }

        const year = parsed.y;

        const month =
            String(parsed.m)
                .padStart(2, '0');

        const day =
            String(parsed.d)
                .padStart(2, '0');

        return `${year}-${month}-${day}`;

      }

      if (typeof value === 'string') {

        return value.trim();

      }

      return '';

    },

    capitalize(value) {

      if (!value) {
        return '';
      }

      return value
          .toLowerCase()
          .replace(
              /(^|\s)\S/g,
              l => l.toUpperCase()
          );

    },

    normalizeText(value) {

      if (!value) {
        return '';
      }

      return value
          .toString()

          /*
          |--------------------------------------------------------------------------
          | REMOVE LINE BREAKS & TABS
          |--------------------------------------------------------------------------
          */

          .replace(/[\r\n\t]+/g, ' ')

          /*
          |--------------------------------------------------------------------------
          | NORMALIZE MULTIPLE SPACES
          |--------------------------------------------------------------------------
          */

          .replace(/\s+/g, ' ')

          /*
          |--------------------------------------------------------------------------
          | NORMALIZE DASHES
          |--------------------------------------------------------------------------
          */

          .replace(/[–—]/g, '-')

          /*
          |--------------------------------------------------------------------------
          | TRIM + LOWERCASE
          |--------------------------------------------------------------------------
          */

          .trim()
          .toLowerCase();

    },

    notify(message, type = 'success') {

      this.$notify({

        message,

        type,

        horizontalAlign: 'right',

        verticalAlign: 'top',

      });

    },

    async loadLocations() {

      try {

        const API_URL =
            process.env.VUE_APP_API_BASE_URL;

        const response =
            await axios.get(
                `${API_URL}/labourers/locations`
            );

        this.locations =
            response.data.data || [];

      } catch (error) {

        console.error(error);

      }

    },

    async loadPorts() {

      try {

        const API_URL =
            process.env.VUE_APP_API_BASE_URL;

        const response =
            await axios.get(
                `${API_URL}/labourers/ports`
            );

        this.ports =
            response.data.data || [];

      } catch (error) {

        console.error(error);

      }

    },

    goBack() {

      this.$router.push({
        name: 'Labourers List'
      });

    },
    async downloadTemplate() {
      try {
        const data = await this.$store.dispatch("labourers/downloadTemplate");
        console.log(data);
        console.log("what is returned");
        const blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        const fileUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = "labourer-template.xlsx";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        window.URL.revokeObjectURL(fileUrl);
      } catch (error) {
        console.error(error);
        this.$notify({
          type: "danger",
          message: "Failed to download template."
        });
      }
    }

  },

};

</script>

<style scoped>

.upload-page {
  padding: 20px;
}

.upload-card {
  border-radius: 16px;
  overflow: hidden;
}

.upload-header {
  background: linear-gradient(
      135deg,
      #1976d2,
      #2196f3
  );
  color: white;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
}

.subtitle {
  margin-top: 5px;
  opacity: 0.9;
}

.header-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.action-btn {
  font-weight: 600;
}

.upload-box {
  border: 2px dashed #dcdcdc;
  border-radius: 16px;
  padding: 40px;
  text-align: center;
  background: #fafafa;
}

.upload-icon .md-icon {
  font-size: 60px !important;
  width: 60px;
  height: 60px;
  color: #2196f3;
}

.upload-description {
  color: #666;
  margin-bottom: 25px;
}

.custom-file-upload {
  display: inline-block;
  cursor: pointer;
}

.custom-file-upload input {
  display: none;
}

.custom-file-upload span {
  background: #2196f3;
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
}

.selected-file {
  margin-top: 20px;
  color: #555;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.summary-wrapper {
  display: grid;
  grid-template-columns:
      repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-top: 30px;
}

.summary-card {
  padding: 24px;
  border-radius: 14px;
  color: white;
  text-align: center;
}

.summary-card.valid {
  background: #4caf50;
}

.summary-card.invalid {
  background: #f44336;
}.summary-card.warning {
  background: #ff9800
}

.summary-card.total {
  background: #2196f3;
}

.summary-number {
  font-size: 32px;
  font-weight: bold;
}

.summary-label {
  margin-top: 6px;
}

.action-bar {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
}

.action-info {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #666;
}

.upload-btn {
  min-width: 220px;
}

.table-container {
  margin-top: 30px;
  overflow: auto;
  border-radius: 14px;
  border: 1px solid #eee;
}

.modern-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 1400px;
}

.modern-table thead th {
  background: #f5f7fa;
  padding: 16px;
  text-align: left;
  font-weight: 700;
  position: sticky;
  top: 0;
  z-index: 2;
}

.modern-table tbody td {
  padding: 14px 16px;
  border-top: 1px solid #eee;
  vertical-align: top;
}

.row-invalid {
  background: #fff5f5;
}

.row-warning {
  background: #fffdf3;
}

.status-badge {
  padding: 6px 12px;
  border-radius: 50px;
  font-size: 12px;
  font-weight: bold;
}

.status-badge.valid {
  background: #e8f5e9;
  color: #2e7d32;
}

.status-badge.invalid {
  background: #ffebee;
  color: #c62828;
}

.status-badge.warning {
  background: #fff8e1;
  color: #f57c00;
}

.validation-column {
  min-width: 320px;
}

.validation-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.validation-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 13px;
  line-height: 1.5;
}

.validation-item.error {
  color: #d32f2f;
}

.validation-item.warning {
  color: #f57c00;
}

.validation-item.success {
  color: #388e3c;
}

.loading-overlay {
  position: fixed;
  inset: 0;
  background: rgba(255,255,255,0.85);
  z-index: 999999;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(4px);
}

.loading-content {
  background: white;
  padding: 40px;
  border-radius: 20px;
  text-align: center;
  box-shadow:
      0 10px 40px rgba(0,0,0,0.15);
}

@media (max-width: 768px) {

  .header-content,
  .action-bar {
    flex-direction: column;
    align-items: stretch;
  }

  .header-actions {
    width: 100%;
  }

  .header-actions .md-button {
    flex: 1;
  }

}

</style>
